import { ChangeDetectionStrategy, Component } from '@angular/core'

import { UIModule } from '@app/modules/ui/ui.module'
import { Confirmable } from '@ui/models/confirmable'

@Component({
  selector: 'sb-message-photo-album-delete-confirm-modal',
  templateUrl: './message-photo-album-delete-confirm-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumDeleteConfirmModalComponent extends Confirmable {}
